<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      // 支持 Element UI icon (el-icon-xxx) 和 SVG icon
      if (icon.startsWith('el-icon-')) {
        vnodes.push(<i class={icon + ' menu-item-icon'}></i>)
      } else {
        vnodes.push(<svg-icon icon-class={icon} class="menu-item-icon"/>)
      }
    }

    if (title) {
      vnodes.push(<span slot='title' class="menu-item-title">{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style lang="scss" scoped>
.menu-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin-right: 5px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.menu-item-title {
  display: inline-block;
  vertical-align: middle;
}
</style>
